import { createSelector } from '@reduxjs/toolkit';

export const getOrdersProfile = (state) => {
    return state.orders.ordersProfile;
};

export const getOrder = createSelector(getOrdersProfile, (profile) => profile.order.data);

export const getOrderSlice = createSelector(getOrdersProfile, (profile) => profile.order);

export const getOrderDiffs = createSelector(getOrderSlice, (order) => order?.orderDiffs);

export const getSearchValue = createSelector(getOrderSlice, (order) => order?.searchValue);

export const getEntityAddRequest = createSelector(
    getOrderSlice,
    (order) => order?.entityAddRequest
);
export const getSelectedProducts = createSelector(
    getOrdersProfile,
    (profile) => profile.order.selectedProducts
);

export const getTotalProducts = createSelector(
    getOrdersProfile,
    (profile) => profile.order.totalProducts
);

export const getSelectedServices = createSelector(
    getOrdersProfile,
    (profile) => profile.order.selectedServices
);

export const getIsAppointPerformerModalOpen = createSelector(
    getOrdersProfile,
    (profile) => profile.order.isAppointPerformerModalVisible
);

export const getTotalServices = createSelector(
    getOrdersProfile,
    (profile) => profile.order.totalServices
);
export const getSelectedTasks = createSelector(
    getOrdersProfile,
    (profile) => profile.order.selectedTasks
);

export const getTotalTasks = createSelector(
    getOrdersProfile,
    (profile) => profile.order.totalTasks
);

export const getSelectedWorksheet = createSelector(
    getOrdersProfile,
    (profile) => profile.order.selectedWorksheet
);

export const getImmutableOrderData = createSelector(
    getOrdersProfile,
    (profile) => profile.order.immutableOrderData
);

export const getOrderObjects = createSelector(
    getOrdersProfile,
    (profile) => profile.order.orderObjects
);

export const getMutableOrderFields = createSelector(
    getOrdersProfile,
    (profile) => profile.order.mutableOrderFields
);

export const getImmutableOrderFields = createSelector(
    getOrdersProfile,
    (profile) => profile.order.immutableOrderFields
);

export const getMutableRequiredOrderFields = createSelector(
    getOrdersProfile,
    (profile) => profile.order.mutableRequiredOrderFields
);

export const getImmutableRequiredOrderFields = createSelector(
    getOrdersProfile,
    (profile) => profile.order.immutableRequiredOrderFields
);

export const getSelectedItemsFromSearchTabs = createSelector(
    getOrdersProfile,
    (profile) => profile.order.selectedItemsFromSearchTabs
);

/** Ключи «вкладка:id» выбранного из поиска в порядке добавления */
export const getSelectedItemsOrder = createSelector(
    getOrdersProfile,
    (profile) => profile.order.selectedItemsOrder
);

export const getOrderCustomerProfileId = createSelector(
    getOrder,
    (order) => order?.customer?.customer_profile?.id
);

export const getOrderFields = createSelector(getOrder, (order) => order?.order_fields);

export const getAllRequiredOrderFields = createSelector(
    getOrder,
    (order) => order?.all_required_empty_order_fields
);

export const getSelectedOrderObjectFromOrder = createSelector(
    getOrder,
    (order) => order?.order_object
);

export const getProductByBarcode = createSelector(
    getOrdersProfile,
    (profile) => profile.order.productByBarcode
);

// Временно
export const getSelectedUnassignedEntities = createSelector(
    getOrdersProfile,
    (profile) => profile.order.selectedUnassignedEntities
);

export const getTotalUnassignedEntities = createSelector(
    getOrdersProfile,
    (profile) => profile.order.totalUnassignedEntities
);
